import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPipingModelTypes } from '../../../api/piping-model-types';

export const getPipingModelTypesAsync = createAsyncThunk(
  'pipingModelTypes/getPipingModelTypes',
  getPipingModelTypes
);

export interface PipingModelType {
  id: number;
  name: string;
}

interface PipingModelTypeState {
  data: PipingModelType[];
}

const initialState: PipingModelTypeState = {
  data: []
};

export default createSlice({
  name: 'pipingModelTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPipingModelTypesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
